<template>
  <div class="container mt-5" v-if="page === 'login'">
  <form>
    <div class="form-group">
      <label>Email address</label>
      <input type="email" class="form-control" v-model="email">
    </div>
    <div class="form-group">
      <label>Password</label>
      <input type="password" class="form-control" v-model="password">
    </div>
    <div class="form-group container row justify-content-between">
      <div class="col form-check">
        <input type="checkbox" class="form-check-input" >
        <label class="form-check-label" >Check me out</label>
      </div>
      <div class="col text-right">
        <span>Haven't an account?
        <button type="button" class="btn btn-md text-right border border-primary" @click.prevent="registerPage">Register</button> or SignIn With: </span>
      </div>

    </div>
    <button type="submit" class="btn btn-success" @click.prevent="login">Login</button>
   
  </form>
</div>
</template>
<script>
import axios from "axios"
export default {
  props: ['page'],
  data: function () {
    return {
      email: '',
      password: '',
    }
  },
  methods: {
    login: function(){
      axios.post('https://protected-taiga-35743.herokuapp.com/user/login', {
        email: this.email,
        password: this.password
      })
      .then(data => {
        console.log(data.data)
        let token = data.data.token
        localStorage.setItem('usertoken', token)
        const Toast = Swal.mixin({
          toast: true,
          position: 'top',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          onOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })

        Toast.fire({
          icon: 'success',
          title: 'Signed in successfully'
        })
        this.$emit('changePage', {page: 'home'})
      })
      .catch(err => {
        Swal.fire({
          icon: 'error',
          title: 'Wrong Email or Password',
          text: 'if you haven\'t an account, Register',
          position: 'top',
        })
        console.log(err)
      })
    },
    registerPage: function(){
      this.$emit('changePage', {page: 'register'})
    },
    googleSign: function onSignIn(googleUser) {
      var profile = googleUser.getBasicProfile();
      console.log('ID: ' + profile.getId()); // Do not send to your backend! Use an ID token instead.
      console.log('Name: ' + profile.getName());
      console.log('Image URL: ' + profile.getImageUrl());
      console.log('Email: ' + profile.getEmail()); // This is null if the 'email' scope is not present.
    }
  }
}
</script>